import { defineMessages } from 'react-intl';

/** Strings shared by the key panels of the user settings modal. */
export const keyMessages = defineMessages({
    addKey: {
        id: 'userSettings.keys.add',
        defaultMessage: 'Nový klíč',
    },
});
